import React, { Component } from "react";
import _8x7 from "./8x7/_8x7";
import _10x8 from "./10x8/_10x8";
import _10x20 from "./10x20/_10x20";
import _12x10 from "./12x10/_12x10";
import _14x15 from "./14x15/_14x15";
import _20x10 from "./28x15/_28x15";
import _28x15 from "./28x15/_28x15";
import _32x15 from "./32x15/_32x15";
import _36x18 from "./36x18/_36x18";

class BasketballCourt extends Component {
  components = {
    Court8x7: _8x7,
    Court10x8: _10x8,
    Court10x20: _10x20,
    Court12x10: _12x10,
    Court14x15: _14x15,
    Court20x10: _20x10,
    Court28x15: _28x15,
    Court32x15: _32x15,
    Court36x18: _36x18,
  };

  render() {
    const BasketBall = this.components[this.props.size] || _8x7;
    return <BasketBall />;
  }
}
export default BasketballCourt;
